'use client'

import React, { memo } from 'react'
import * as S from './styles'

function getYouTubeId(input) {
  const patterns = [
    /(?:v=|vi=)([A-Za-z0-9_-]{11})/,
    /youtu\.be\/([A-Za-z0-9_-]{11})/,
    /\/shorts\/([A-Za-z0-9_-]{11})/,
    /\/embed\/([A-Za-z0-9_-]{11})/,
    /^([A-Za-z0-9_-]{11})$/,
  ]
  for (const r of patterns) {
    const m = input.match(r)
    if (m?.[1]) return m[1]
  }
  return null
}

function getYouTubePlaylistId(input) {
  try {
    const url = new URL(input)
    const list = url.searchParams.get('list')
    if (list) return list
  } catch {}
  return null
}

function buildYouTubeEmbedSrc(raw) {
  const playlistId = getYouTubePlaylistId(raw)
  const videoId = getYouTubeId(raw)

  const params = new URLSearchParams({
    rel: '0',
    modestbranding: '1',
  })

  if (playlistId && !videoId) {
    return `https://www.youtube-nocookie.com/embed/videoseries?list=${encodeURIComponent(
      playlistId
    )}&${params.toString()}`
  }

  if (videoId) {
    return `https://www.youtube-nocookie.com/embed/${videoId}?${params.toString()}`
  }
  if (/^https:\/\/www\.youtube(-nocookie)?\.com\/embed\//i.test(raw)) {
    return raw
  }

  return null
}

const Video = ({ url, options = {}, ...props }) => {
  const src = buildYouTubeEmbedSrc(url)

  if (!src) {
    console.warn('Video: URL/ID YouTube non valido:', url)
    return null
  }

  return (
    <S.Video>
      <iframe
        width='100%'
        height='100%'
        src={src}
        title='YouTube video player'
        allow='accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
        allowFullScreen
        referrerPolicy='strict-origin-when-cross-origin'
        {...props}
      />
    </S.Video>
  )
}

export default memo(Video, (prev, next) => {
  const sameUrl = prev.url === next.url
  const sameRest =
    JSON.stringify({ ...prev, url: undefined }) ===
    JSON.stringify({ ...next, url: undefined })
  return sameUrl && sameRest
})
